var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnquiries(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2093 3.01092L11.4412 5.49501C11.6092 5.8408 12.0571 6.17249 12.4351 6.236L14.6678 6.61002C16.0957 6.84997 16.4317 7.89441 15.4028 8.92474L13.667 10.6749C13.373 10.9713 13.212 11.5429 13.303 11.9522L13.8 14.1187C14.1919 15.8336 13.289 16.497 11.7842 15.6007L9.69139 14.3516C9.31346 14.1258 8.69053 14.1258 8.30553 14.3516L6.21279 15.6007C4.71495 16.497 3.80506 15.8265 4.19701 14.1187L4.69396 11.9522C4.78494 11.5429 4.62397 10.9713 4.32999 10.6749L2.59419 8.92474C1.5723 7.89441 1.90127 6.84997 3.32911 6.61002L5.56186 6.236C5.93282 6.17249 6.38077 5.8408 6.54875 5.49501L7.7806 3.01092C8.45253 1.66303 9.54439 1.66303 10.2093 3.01092Z",
    stroke: "#00424B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiries);
export default __webpack_public_path__ + "static/media/Enquiries.454afc18d2b6bc7de1e1665cab76f110.svg";
export { ForwardRef as ReactComponent };